module.exports = __webpack_public_path__ + "static/img/PSD16-SF_W1.167c15c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/params/mini/PSD16-SF_W1.png
// module id = UdxU
// module chunks = 1